const ActiveCountries  = ['IN', 'QA', 'AE', 'SA', 'KW', 'BH', 'OM', 'UK', 'GB']

export default ActiveCountries;